import { useEffect } from 'react'

export function useDialogCleanup(open: boolean) {
  useEffect(() => {
    if (!open) {
      const cleanup = () => {
        const body = window.document.body
        if (!body) return

        if (body.style.pointerEvents === 'none') {
          body.style.pointerEvents = ''
        }

        const closedDialogs = window.document.querySelectorAll(
          '[role="dialog"][aria-hidden="true"]:not([data-state="open"])'
        )
        closedDialogs.forEach((dialog) => {
          dialog.removeAttribute('aria-hidden')
        })

        const activeElement = window.document.activeElement
        if (activeElement instanceof HTMLElement) {
          const hiddenAncestor = activeElement.closest('[aria-hidden="true"]:not([data-state="open"])')
          if (hiddenAncestor) {
            activeElement.blur()
          }
        }

        const portals = window.document.querySelectorAll('[data-radix-portal]')
        portals.forEach((portal) => {
          const element = portal as HTMLElement
          if (element.style.pointerEvents === 'none') {
            element.style.pointerEvents = ''
          }
        })
      }

      const timeoutId = setTimeout(cleanup, 200)
      return () => clearTimeout(timeoutId)
    }
  }, [open])
}

